export default __webpack_public_path__ + "static/media/14.97c6c0ff.png";